import { Project } from '@work4all/models/lib/Classes/Project.entity';

import { ITranslatedCellProps } from './TranslatedCell';

export type IProjectDirectoryCellProps = ITranslatedCellProps & {
  row: {
    original: Project;
  };
};

export const ProjectDirectoryCell = (props: IProjectDirectoryCellProps) => {
  const {
    value,
    row: { original: rowData },
  } = props;

  const directoryValue = value || rowData?.documentDirectory;

  return <div>{directoryValue}</div>;
};
